import { render, staticRenderFns } from "./singlechoice.vue?vue&type=template&id=69eb26dd&scoped=true"
import script from "./singlechoice.vue?vue&type=script&lang=js"
export * from "./singlechoice.vue?vue&type=script&lang=js"
import style0 from "./singlechoice.vue?vue&type=style&index=0&id=69eb26dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69eb26dd",
  null
  
)

export default component.exports